export const CUSTOM_ROLE_BASES = ["viewer", "cashier", "accountant"];
export const TEAM_PERMISSION_MODULES = [
    "sales_invoices", "sales_notes", "pos", "purchases", "support_documents",
    "received_documents", "customers", "products", "payroll", "banking",
    "accounting", "chart_accounts", "reports", "taxes", "inventory", "files", "imports", "dian_config",
];
/** Custom roles only reduce a built-in template. They never grant owner/admin powers. */
export function templatePermissions(base) {
    if (base === "cashier")
        return ["sales_invoices.read", "sales_invoices.write", "customers.read", "customers.write", "products.read"];
    return TEAM_PERMISSION_MODULES.flatMap(module => base === "viewer" || module === "reports"
        ? [`${module}.read`]
        : [`${module}.read`, `${module}.write`]);
}
export function normalizeTeamPermissions(base, values) {
    if (!CUSTOM_ROLE_BASES.includes(base))
        throw new Error("Plantilla no válida.");
    const ceiling = new Set(templatePermissions(base));
    if (values.some(value => !ceiling.has(value)))
        throw new Error("El permiso no pertenece a la plantilla seleccionada.");
    const result = new Set(values);
    for (const value of result)
        if (value.endsWith(".write"))
            result.add(value.replace(/\.write$/, ".read"));
    if (["sales_invoices", "sales_notes", "pos", "purchases", "support_documents"].some(module => result.has(`${module}.write`))) {
        result.add("customers.read");
        result.add("products.read");
    }
    if (result.has("sales_notes.write"))
        result.add("sales_invoices.read");
    if (result.has("inventory.write"))
        result.add("products.read");
    if (["banking", "accounting", "products", "purchases"].some(module => result.has(`${module}.write`)))
        result.add("chart_accounts.read");
    if (base !== "cashier" && customRoleHasDocumentAccess([...result]))
        result.add("dian_config.read");
    return [...result].sort();
}
/** Undefined is a built-in role. An empty custom-role grant denies every module. */
export function permitsTeamPermission(permissions, permission) {
    if (permissions === undefined)
        return true;
    return permission !== undefined && permissions.includes(permission);
}
export function customRoleHasDocumentAccess(permissions) {
    return ["sales_invoices", "sales_notes", "pos", "support_documents", "payroll"].some(module => permissions.includes(`${module}.read`));
}
//# sourceMappingURL=team-permissions.js.map